import {
  FETCHING_GALLERY,
  FETCHING_GALLERY_FAILED,
  FETCHING_GALLERY_SUCCESS,

  // ADD_GALLERY,
  // ADD_GALLERY_FAILED,
  // ADD_GALLERY_SUCCESS,

  // DELETE_GALLERY,
  // DELETE_GALLERY_FAILED,
  // DELETE_GALLERY_SUCCESS,
  FETCHING_CATEGORY_GALLERY,
  FETCHING_CATEGORY_GALLERY_SUCCESS,
  FETCHING_CATEGORY_GALLERY_FAILED,

} from "./types.js";
// import { includes } from 'lodash';

export const initialState = {
  fetchingGallery: false,
  addingGallery: false,
  deletingGallery: false,
  fetchingCategoryGallery: false,
  activeCategoryGallery: [],
  deletingIds: [],
  
  galleryCategory: []
};

export const galleryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_GALLERY:
      return {
        ...state,
        fetchingGallery: true,
      };
    case FETCHING_GALLERY_FAILED:
      return {
        ...state,
        fetchingGallery: false,
        gallery: [],
      };
    case FETCHING_GALLERY_SUCCESS:
      return {
        ...state,
        fetchingGallery: false,
        galleryCategory: action?.gallery,
      };
    case FETCHING_CATEGORY_GALLERY: 
        return {
          ...state,
          fetchingCategoryGallery: true,
          activeCategoryGallery: [],
        }
    case FETCHING_CATEGORY_GALLERY_SUCCESS: 
        return {
          ...state,
          fetchingCategoryGallery: false,
          activeCategoryGallery: action?.gallery,
        }
    case FETCHING_CATEGORY_GALLERY_FAILED: 
        return {
          ...state,
          fetchingCategoryGallery: false,
          activeCategoryGallery: []
        }
      

    // case ADD_GALLERY:
    //   return {
    //     ...state,
    //     addingGallery: true,
    //   };
    // case ADD_GALLERY_FAILED:
    //   return {
    //     ...state,
    //     addingGallery: false,
    //   };
    // case ADD_GALLERY_SUCCESS:
    //   return {
    //     ...state,
    //     addingGallery: false,
    //     gallery: {
    //       ...state?.gallery,
    //       data: [action?.picture, ...state?.gallery?.data],
    //     },
    //   };
    // case DELETE_GALLERY:
    //   return {
    //     ...state,
    //     deletingGallery: true,
    //     deletingIds: action?.ids,
    //   };
    // case DELETE_GALLERY_FAILED:
    //   return {
    //     ...state,
    //     deletingGallery: false,
    //     deletingIds: [],
    //   };
    // case DELETE_GALLERY_SUCCESS: {
    //   const ids = action?.ids;
    //   const updatedGalleryList = state?.gallery?.data?.filter((gallery) => {
    //     const isDeleted = includes(ids, gallery?.id);
    //     return !isDeleted;
    //   });
    //   return {
    //     ...state,
    //     deletingGallery: false,
    //     deletingIds: [],
    //     gallery: {
    //       ...state?.gallery,
    //       data: updatedGalleryList,
    //     },
    //   };
    // }
    default:
      return state;
  }
};
